import { World } from "./testCase";
import MoveTestCase from "./moveTestCase";
class MoveToFindOneArgumentRoot extends World {
    constructor(testCase) {
        super(testCase);
        this._moveTestCase = testCase;
    }
    findHomeX() {
        this.log("Found Home X at " + this._moveTestCase.goalX);
        return this._moveTestCase.goalX;
    }
    moveToX(x) {
        this._moveTestCase.log("Move to X " + x);
        this._moveTestCase.moveTo(x, this._moveTestCase.itemY);
    }
    findHomeY() {
        this.log("Found Home Y at " + this._moveTestCase.goalY);
        return this._moveTestCase.goalY;
    }
    moveToY(y) {
        this._moveTestCase.log("Move to Y " + y);
        this._moveTestCase.moveTo(this._moveTestCase.itemX, y);
    }
}
export class MoveToFindOneArgumentTestCase extends MoveTestCase {
    //sceneNode is shared.
    createRoot() {
        return new MoveToFindOneArgumentRoot(this);
    }
    //styleSheet is shared
    createElement(document) {
        let template = document.createElement("template");
        let html = `<div class="move-container">
      <div>
        <div>
          <button class="find_x_button w-full btn-darkBackHigh">Find Home X</button>
        </div>
        <div>
          <input type="number" readonly="true" class="find_x_value move_value w-full bg-darkBack text-darkFore outline-none" min="-9" max="9" value="0">
        </div>
        <div>
          <input type="number" class="x_value move_value w-full bg-darkBack text-darkFore outline-none" min="-9" max="9" value="0">
        </div>
        <div>
          <button class="move_x_button w-full btn-darkBackHigh">Move To X</button>
        </div>
        <br/>
        <div>
          <button class="find_y_button w-full btn-darkBackHigh">Find Home Y</button>
        </div>
        <div>
          <input type="number" readonly="true" class="find_y_value move_value w-full bg-darkBack text-darkFore outline-none" min="-9" max="9" value="0">
        </div>
        <div>
          <input type="number" class="y_value move_value w-full bg-darkBack text-darkFore outline-none" min="-9" max="9" value="0">
        </div>
        <div>
          <button class="move_y_button w-full btn-darkBackHigh">Move To Y</button>
        </div>
      </div>
    </div>`;
        html = html.trim(); // Never return a text node of whitespace as the result
        template.innerHTML = html;
        //Find X
        let findX = template.content.firstElementChild
            .getElementsByClassName("find_x_value")[0];
        template.content.firstElementChild
            .getElementsByClassName("find_x_button")[0]
            .addEventListener("click", () => {
            this.log("Found Home X at " + this.goalX);
            findX.value = this.goalX.toString();
            this.queueEvaluate();
        });
        //Move To X
        let xValue = template.content.firstElementChild
            .getElementsByClassName("x_value")[0];
        template.content.firstElementChild
            .getElementsByClassName("move_x_button")[0]
            .addEventListener("click", () => {
            let x = xValue.valueAsNumber;
            this.log("Move To X " + x);
            this.moveTo(x, this._itemY);
            this.queueEvaluate();
        });
        //Find Y
        let findY = template.content.firstElementChild
            .getElementsByClassName("find_y_value")[0];
        template.content.firstElementChild
            .getElementsByClassName("find_y_button")[0]
            .addEventListener("click", () => {
            this.log("Found Home Y at " + this.goalY);
            findY.value = this.goalY.toString();
            this.queueEvaluate();
        });
        //Move To Y
        let yValue = template.content.firstElementChild
            .getElementsByClassName("y_value")[0];
        template.content.firstElementChild
            .getElementsByClassName("move_y_button")[0]
            .addEventListener("click", () => {
            let y = yValue.valueAsNumber;
            this.log("Move To Y " + y);
            this.moveTo(this._itemX, y);
            this.queueEvaluate();
        });
        return template.content.firstElementChild;
    }
}
